import { forwardRef } from 'react';

import { ListItemInput, ListItemInputProps } from './ListItemInput';
import { Switch, SwitchProps } from '../switch/Switch';

export interface ListItemSwitchProps extends Omit<ListItemInputProps, 'ref'> {
  /**
   * Props for the underlying input (checkbox, radio, switch)
   */
  inputProps?: SwitchProps;
  /**
   * Ref for the underlying input
   */
  ref?: React.ForwardedRef<HTMLButtonElement>;
}

export const ListItemSwitch = forwardRef<HTMLButtonElement, ListItemSwitchProps>(
  ({ classNames = [], inputProps, ...props }: ListItemSwitchProps, ref: ListItemSwitchProps['ref']) => {
    const { ref: inputRef, ...otherProps } = props;
    return (
      <ListItemInput {...otherProps} classNames={classNames}>
        <Switch
          ref={ref}
          {...inputProps}
          isChecked={props.isSelected}
          onClick={() => otherProps.handleClick?.(props.id)}
        />
      </ListItemInput>
    );
  },
);
ListItemSwitch.displayName = 'ListItemSwitch';
